<template>
  <section
    id="new-hospitals-creation"
    class="case-creation"
    v-loading="loading"
  >
    <div class="container-small-table">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Add Ordering Facility</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <el-form :model="hospitalData">
                <el-row gutter="20">
                  <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Ordering Facility Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="hospitalData.name"
                          placeholder="Enter Ordering Facility"
                          class="el-input convert-upper"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="2" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text"
                          >Code<span class="star">*</span></label
                        >
                        <el-input
                          v-model="hospitalData.code"
                          placeholder="Enter Code"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="code"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text"
                          >Phone Number<span class="star">*</span></label
                        >
                        <el-input
                          maxlength="10"
                          v-model="hospitalData.phone"
                          placeholder="Enter Phone Number"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="phone"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Fax</label>
                        <el-input
                          maxlength="10"
                          v-model="hospitalData.fax"
                          placeholder="Enter Fax"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="fax"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Email</label>
                        <el-input
                          v-model="hospitalData.email"
                          placeholder="Enter Email"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="email"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Address Line 1</label>
                        <el-input
                          v-model="hospitalData.address_line_1"
                          placeholder="Enter Address Line 1"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="address_line_1"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="5" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Address Line 2</label>
                        <el-input
                          v-model="hospitalData.address_line_2"
                          placeholder="Enter Address Line 2"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="address_line_2"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="2" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Zip<span class="star">*</span></label>
                        <el-input
                          maxlength="5"
                          placeholder="Enter Zip"
                          v-model="hospitalData.zip"
                          @input="getStateCity"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="zip"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <state :stateData="hospitalData"></state>

                        <p class="err">
                          <FormError errorName="state"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <city :cityData="hospitalData"></city>

                        <p class="err">
                          <FormError errorName="city"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">NPI<span class="star">*</span></label>
                        <el-input
                          maxlength="10"
                          placeholder="Enter NPI"
                          v-model="hospitalData.npi"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="npi"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text"
                          >Sales Rep<span class="star">*</span></label
                        >
                        <el-select
                          v-model="hospitalData.facility_marketer"
                          placeholder="Select Sales Rep"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="(user, index) in marketerData"
                            :key="index"
                            :label="user.first_name + ' ' + user.last_name"
                            :value="user._id"
                          >
                          </el-option>
                        </el-select>
                        <p class="err error-break">
                          <FormError errorName="facility_marketer"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text"
                          >Account Manager<span class="star">*</span></label
                        >
                        <el-select
                          v-model="hospitalData.account_managers"
                          placeholder="Select Sales Rep"
                          default-first-option
                          :reserve-keyword="false"
                          filterable
                          clearable
                          multiple
                          collapse-tags
                        >
                          <el-option
                            v-for="(user, index) in accountManagersData"
                            :key="index"
                            :label="user.first_name + ' ' + user.last_name"
                            :value="user._id"
                          >
                          </el-option>
                        </el-select>
                        <p class="err error-break">
                          <FormError errorName="account_managers"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">Labdaq Code</label>
                        <el-input
                          v-model="hospitalData.labdaq_code"
                          placeholder="Enter Labdaq Code"
                        ></el-input>
                        <p class="err error-break">
                          <FormError errorName="labdaq_code"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <label for="text">&nbsp;</label>

                      <el-upload
                        name="logo"
                        action
                        :on-change="uploadFile"
                        :show-file-list="false"
                        :auto-upload="false"
                        accept=".pdf"
                      >
                        <el-button class="btn radius-button round-button">
                          <span>
                            <img
                              src="@/assets/images/icons/attachment-icon-v2.svg"
                              alt=""
                            /> </span
                          >UPLOAD ACCOUNT SETUP FORM</el-button
                        >
                      </el-upload>
                      <div class="attachment-upload">
                        <a v-if="selectedFileName">
                          <div class="content">
                            <div class="text">
                              <p>
                                {{ selectedFileName }}
                              </p>
                            </div>
                          </div>
                          <ul class="actions">
                            <li>
                              <el-button @click="remove" class="remove-button">
                                <el-icon><close /></el-icon>
                              </el-button>
                            </li>
                          </ul>
                        </a>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <p
            class="err"
            v-if="
              getHospitalValidationErrors &&
              getHospitalValidationErrors.critical_error
            "
          >
            <FormError errorName="critical_error"></FormError>
          </p>
        </div>
                
        <!-- Contact Information Section -->
        <div class="case-creation__card mt-10">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">CONTACT INFORMATION</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <el-form :model="hospitalData">
                <!-- Critical Reporting Point of Contact -->
                <div class="contact-section mb-20">
                  <h4 class="contact-section-title  mb-20">Critical Reporting Point of Contact</h4>
                  <el-row :gutter="20">
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Name</label>
                          <el-input
                            v-model="hospitalData.contact_poc.name"
                            placeholder="Enter Name"
                            class="el-input convert-upper"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="contact_poc.name"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Email</label>
                          <el-input
                            v-model="hospitalData.contact_poc.email"
                            placeholder="Enter Email"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="contact_poc.email"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Phone Number</label>
                          <el-input
                            maxlength="10"
                            v-model="hospitalData.contact_poc.phone_number"
                            placeholder="Enter Phone Number"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="contact_poc.phone_number"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <!-- Rejections and Recollections Point of Contact -->
                <div class="contact-section">
                  <h4 class="contact-section-title  mb-20">Rejections and Recollections Point of Contact</h4>
                  <el-row :gutter="20">
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Name</label>
                          <el-input
                            v-model="hospitalData.rejection_poc.name"
                            placeholder="Enter Name"
                            class="el-input convert-upper"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="rejection_poc.name"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Email</label>
                          <el-input
                            v-model="hospitalData.rejection_poc.email"
                            placeholder="Enter Email"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="rejection_poc.email"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                      <div class="case-creation__input">
                        <el-form-item class="mb-15">
                          <label for="text">Phone Number</label>
                          <el-input
                            maxlength="10"
                            v-model="hospitalData.rejection_poc.phone_number"
                            placeholder="Enter Phone Number"
                          ></el-input>
                          <p class="err">
                            <FormError errorName="rejection_poc.phone_number"></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="case-creation__card mt-10">
          <div class="hospitals-settings">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-case-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">ORDERING FACILITY SETTINGS</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="radio-buttons-alignments">
                <el-form>
                  <el-row>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Auto Fax :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.auto_fax"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.auto_fax"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Email Notifications :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.email_notifications"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.email_notifications"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Requires Inhouse Phlebotomist :"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.requires_inhouse_phlebotomist"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.requires_inhouse_phlebotomist"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Daily Statistics :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.daily_statistics"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.daily_statistics"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Labdaq :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.is_labdaq"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.is_labdaq"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Uni Direction EMR :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.emr_unidirectional_status"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.emr_unidirectional_status"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Restrict Insurance :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.restrict_insurance"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.restrict_insurance"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Notify Rejections :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.notify_rejections"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.notify_rejections"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Release :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.release_note"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.release_note"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Sample Collection Type :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio v-model="form.sample_collection_type" value="HOME" label="HOME">Home</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="INCLINIC" label="INCLINIC">In Clinic</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="BOTH" label="BOTH">Both</el-radio>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Daily Sample Pickup :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="form.is_daily_sample_pickup"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.is_daily_sample_pickup"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="12">
                      <div class="case-creation__input">
                        <label for="">Pickup Days</label>
                        <el-checkbox-group v-model="form.pickup_days" style="display: flex; flex-wrap: wrap; gap: 10px;">
                          <el-checkbox
                            v-for="day in ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                            :key="day"
                            :label="day"
                          >{{ day }}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup Time</label>
                        <el-input
                          v-model="form.pickup_time"
                          placeholder="Enter pickup time (e.g. 09:00 AM)"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="24">
                      <div class="case-creation__input d-flex" style="justify-content: space-between; align-items: center;">
                        <label for="">Pickup Address</label>
                        <el-button type="text" @click="fillPickupAddressFromFacility">Same as Facility Address</el-button>
                      </div>
                      <el-input
                        v-model="form.pickup_address"
                        placeholder="Enter pickup address"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup Zip</label>
                        <el-input v-model="form.pickup_zip" maxlength="5" placeholder="Zip"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup City</label>
                        <el-input v-model="form.pickup_city" placeholder="City"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup State</label>
                        <el-input v-model="form.pickup_state" placeholder="State"></el-input>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="case-creation__card mt-10">
          <div class="hospitals-settings">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-case-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">PATIENT REPORT SETTINGS</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="radio-buttons-alignments">
                <el-form>
                  <el-row>
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >Send Finalized Report To Patient
                          <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.send_finalized_report_to_patient"
                              @change="resetSettings"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.send_finalized_report_to_patient === true">
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >Email Sending <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group v-model="form.email_sending">
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" v-if="form.email_sending === true">
                      <div class="case-creation__input">
                        <label for=""
                          >All Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.for_all_case_types"
                              @change="clearEmailCaseTypes"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="8"
                      v-if="
                        form.for_all_case_types === false &&
                        form.email_sending === true
                      "
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Select Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-select
                              multiple
                              filterable
                              v-model="form.case_types"
                              placeholder="Select Case type"
                              collapse-tags
                            >
                              <el-option
                                v-for="(
                                  caseType, index
                                ) of this.getLabBasedCaseTypes(caseTyeData)"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                          </div>
                          <p class="err">
                            <FormError
                              errorName="settings.patient_report_settings.email_sending_data.for_specific_case_types"
                            ></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.send_finalized_report_to_patient === true">
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >SMS Sending <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group v-model="form.sms_sending">
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" v-if="form.sms_sending === true">
                      <div class="case-creation__input">
                        <label for=""
                          >All Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.sms_for_all_case_types"
                              @change="clearSMSCaseTypes"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="8"
                      v-if="
                        form.sms_for_all_case_types === false &&
                        form.sms_sending === true
                      "
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Select Case Types<span class="star">*</span>
                        </label>
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-select
                              multiple
                              filterable
                              v-model="form.sms_case_types"
                              placeholder="Select Case type"
                              collapse-tags
                            >
                              <el-option
                                v-for="(
                                  caseType, index
                                ) of this.getLabBasedCaseTypes(caseTyeData)"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                          </div>
                          <p class="err">
                            <FormError
                              errorName="settings.patient_report_settings.sms_sending_data.for_specific_case_types"
                            ></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="case-creation__actions">
        <ul class="list">
          <li>
            <el-button
              type="button"
              class="btn cancel-button"
              @click="cancelHospitalDetails"
            >
              Cancel
            </el-button>
          </li>
          <li>
            <el-button
              type="button"
              class="btn save-button"
              @click="submitHospitalDetails"
              >Save</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import caseDataHelper from "@/mixins/caseDataHelper";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  data() {
    return {
      loading: false,
      hospitalData: {
        city: "",
        contact_poc: {
          name: "",
          email: "",
          phone_number: "",
        },
        rejection_poc: {
          name: "",
          email: "",
          phone_number: "",
        },
      },
      caseTyeData: caseConstants.CASE_TYPES_DATA,
      form: {
        auto_fax: false,
        email_notifications: false,
        requires_inhouse_phlebotomist: false,
        daily_statistics: false,
        send_finalized_report_to_patient: false,
        case_types: [],
        sms_case_types: [],
        for_all_case_types: true,
        sms_for_all_case_types: true,
        email_sending: false,
        sms_sending: false,
        reporting_settings: [],
        is_labdaq: false,
        emr_unidirectional_status: false,
        restrict_insurance: false,
        notify_rejections: false,
        release_note: false,
        sample_collection_type: "",
        is_daily_sample_pickup: false,
        pickup_time: "",
        pickup_days: [],
        pickup_address: "",
        pickup_zip: "",
        pickup_city: "",
        pickup_state: "",
      },
      disableSubmitButton: false,
      marketerData: [],
      selectedFile: null,
      selectedFileName: null,
      accountManagersData: [],
    };
  },
  mixins: [caseDataHelper, UserPermissionsHelper],
  components: {
    state,
    city,
    FormError,
  },
  computed: {
    ...mapGetters("hospitals", [
      "getHospitalAddStatus",
      "getHospitalValidationErrors",
      "getAddedHospitalData",
      "getUplodConsentFormStatus",
      "getFileUploadURLForAttachments",
    ]),
    ...mapGetters("errors", ["getError"]),
    ...mapGetters("cases", [
      "getStateAndCity",
      "getAttachmentUploadStatusForAttachments",
    ]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
  },
  async mounted() {
    this.$store.dispatch("hospitals/clearValidationErrors");
    this.$store.dispatch("help/fetchAllStates");
    await this.fetchAllUsers();
  },
  methods: {
    remove() {
      (this.selectedFile = null), (this.selectedFileName = "");
    },
    uploadFile(file) {
      if (!file.raw.type.includes("pdf")) {
        this.$message.error("Only PDF files are allowed.");
        return;
      }
      this.selectedFile = file.raw;
      this.selectedFileName = file.raw.name;
      this.getFileUploadUrl(file);
    },
    async getFileUploadUrl(file) {
      try {
        this.loading = true;
        let data = {
          file: file.raw.name,
          file_type: file.raw.type,
          file_size: file.raw.size / 1000,
        };
        await this.$store.dispatch("hospitals/fetchDocumentUploadUrl", data);
        if (this.getUplodConsentFormStatus) {
          let params = {
            file: this.selectedFile,
            upload_url: this.getFileUploadURLForAttachments.target_url,
          };
          await this.$store.dispatch(
            "cases/uploadDocumentToGeneratedUrlForAttachments",
            params
          );
          if (this.getAttachmentUploadStatusForAttachments) {
            successNotification("Account setup form uploaded successfully");
          } else {
            errorNotification("Error while uploading account setup form");
          }
        } else {
          errorNotification("Error while uploading account setup form");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async fetchAllUsers() {
      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        user_types: [
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "REGIONAL_DIRECTOR",
          "ACCOUNT_MANAGER",
        ],
        status:"ACTIVE"
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let accountUser = [
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "REGIONAL_DIRECTOR",
        ];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          accountUser.includes(item.user_type)
        );
      }
      let accountUser = ["ACCOUNT_MANAGER"];
      this.accountManagersData = this.getAllUsers.data.filter((item) =>
        accountUser.includes(item.user_type)
      );
    },
    resetSettings() {
      this.form.email_sending = false;
      this.form.case_types = [];
      this.form.for_all_case_types = true;
      this.form.sms_sending = false;
      this.form.sms_case_types = [];
      this.form.sms_for_all_case_types = true;
    },
    clearEmailCaseTypes() {
      this.form.case_types = [];
    },
    clearSMSCaseTypes() {
      this.form.sms_case_types = [];
    },
    fillPickupAddressFromFacility() {
      this.form.pickup_address = this.hospitalData.address_line_1 || "";
      this.form.pickup_zip = this.hospitalData.zip || "";
      this.form.pickup_city = this.hospitalData.city || "";
      this.form.pickup_state = this.hospitalData.state || "";
    },
    async getStateCity() {
      try {
        let params = {
          zip: this.hospitalData.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.hospitalData.state = this.getStateAndCity.state;
          this.hospitalData.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    goToHospitals() {
      this.hospitalData = {};
      if (this.$route.query && this.$route.query.redirectRoute) {
        let query = this.$route.query;
        let redirectRoute = this.$route.query.redirectRoute;
        delete query.redirectRoute;
        this.$router.push({
          name: redirectRoute,
          query: query,
        });
      } else {
        this.$router.push({ path: "/ordering-facilities" });
      }
    },
    goToHospitalDetails(id) {
      this.$router.push({
        name: "Hospital-Primary-Information",
        params: { hospital_id: id },
      });
    },
    prepareHospitalAddData() {
      let params = { ...this.hospitalData };
      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      if (params.name) {
        params.name = params.name.toUpperCase();
      }
      params.settings = {
        daily_statistics: this.form.daily_statistics || false,
        auto_fax: this.form.auto_fax || false,
        email_notifications: this.form.email_notifications || false,
        requires_inhouse_phlebotomist:
          this.form.requires_inhouse_phlebotomist || false,
        patient_report_settings: {
          send_finalized_report_to_patient:
            this.form.send_finalized_report_to_patient || false,
          sms_sending_data: {
            for_specific_case_types: this.form.sms_case_types || [],
            status: this.form.sms_sending || false,
            for_all_case_types: this.form.sms_for_all_case_types,
          },
          email_sending_data: {
            for_specific_case_types: this.form.case_types || [],
            status: this.form.email_sending || false,
            for_all_case_types: this.form.for_all_case_types,
          },
        },
        reporting_settings: this.form.reporting_settings || [],
        is_labdaq: this.form.is_labdaq || false,
        emr_unidirectional_status: this.form.emr_unidirectional_status || false,
        restrict_insurance: this.form.restrict_insurance || false,
        notify_rejections: this.form.notify_rejections || false,
        release_note: this.form.release_note || false,
        sample_collection_type: this.form.sample_collection_type || "",
        is_daily_sample_pickup: this.form.is_daily_sample_pickup || false,
        pickup_time: this.form.pickup_time || "",
        pickup_days: this.form.pickup_days || [],
        pickup_address: this.form.pickup_address || "",
        pickup_zip: this.form.pickup_zip || "",
        pickup_city: this.form.pickup_city || "",
        pickup_state: this.form.pickup_state || "",
      };

      return params;
    },
    async submitHospitalDetails() {
      try {
        this.loading = true;
        this.disableSubmitButton = true;

        const payload = this.prepareHospitalAddData();
        if (
          this.selectedFile &&
          this.getFileUploadURLForAttachments &&
          this.getFileUploadURLForAttachments.data
        ) {
          payload.attachments = [
            {
              name: this.getFileUploadURLForAttachments.path,
              path: this.getFileUploadURLForAttachments.path,
              metadata: this.getFileUploadURLForAttachments.data.metadata,
            },
          ];
        }
        if (this.hospitalData.facility_marketer) {
          payload.facility_marketer = [this.hospitalData.facility_marketer];
        } else {
          payload.facility_marketer = [];
        }
        if (this.hospitalData.account_managers) {
          payload.account_managers = this.hospitalData.account_managers;
        } else {
          payload.account_managers = [];
        }
        await this.$store.dispatch("hospitals/addHospital", payload);

        if (this.getHospitalAddStatus) {
          const newHospitalId = this.getAddedHospitalData._id;

          successNotification("New Ordering Facility added successfully");

          this.goToHospitalDetails(newHospitalId);
        } else if (this.getHospitalValidationErrors) {
          this.scrollToFirstError();
        } else if (this.getHospitalValidationErrors.critical_error) {
          errorNotification(this.getHospitalValidationErrors.critical_error);
        }

        this.disableSubmitButton = false;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("error")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    cancelHospitalDetails() {
      if (Object.keys(this.hospitalData).length === 0) {
        this.goToHospitals();
      } else {
        this.$confirm(
          "Are you sure to cancel adding new ordering facility?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          this.goToHospitals();
        });
      }
    },
  },
};
</script>
<style lang="scss">
#new-hospital {
  padding-top: 15px;
  padding-bottom: 25px;
  width: 70%;
  margin: 0 auto;
  .page-title {
    margin-bottom: 35px;
    h4 {
      font-size: 1.1em;
      color: #0a1b4b;
      span {
        padding-right: 5px;
      }
    }
  }
}
.err {
  margin-top: 2px !important;
  color: #eb5757;
  font-size: 12px;
  min-height: 20px;
  white-space: nowrap;
  line-height: 20px;
  font-weight: 500;
  padding-left: 2px;
}
.radio-buttons-alignments {
  .el-radio__input .el-radio__inner {
    border-color: transparent;
    box-shadow: 0 0 0 1px #ced1d6;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #0a5da6;
    border-color: #ffffff;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #0a5da6;
  }
  .case-creation__input .el-form-item {
    margin-top: 10px;
    margin-bottom: 0px !important;
  }
}
.hospitals-settings {
  .el-select {
    max-width: 300px;
  }
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
